/**
 * <map-embed> — click-to-load facade for sections/map-embed.liquid.
 * The Google Maps iframe sits in a <template>; it is appended (and the facade removed) when the
 * visitor presses "Show map", or immediately when sessionStorage says they already did on this site.
 */
class MapEmbed extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[ref="showButton"]');
    this.button?.addEventListener('click', () => this.show(true));
    let remembered = false;
    try {
      remembered = sessionStorage.getItem(this.dataset.storageKey || 'map-embed') === '1';
    } catch {
      remembered = false;
    }
    if (remembered) this.show(false);
  }

  show(remember) {
    const template = this.querySelector('template');
    if (!template) return;
    this.querySelector('[ref="facade"]')?.remove();
    this.append(template.content.cloneNode(true));
    template.remove();
    if (remember) {
      try {
        sessionStorage.setItem(this.dataset.storageKey || 'map-embed', '1');
      } catch {
        /* storage unavailable — the map still shows for this view */
      }
    }
  }
}

if (!customElements.get('map-embed')) customElements.define('map-embed', MapEmbed);
